import config from "../config";
import router from "../router";
import jwt from "jwt-decode";
import axios from "axios";
var cookies = require("vue-cookies");
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");

export default {
    state: {
        profile: null,
        idToken: null,
        featureFlags: [],
        isAuthenticated: false,
        errmsg: "",
        destination: "",
    },

    mutations: {
        setProfile: (state, profile) => 
        {
            state.profile = profile;
        },
        setIdToken: (state, idToken) => 
        {
            state.idToken = idToken;
        },
        setFeatureFlags: (state, featureFlags) => 
        {
            state.featureFlags = featureFlags;
        },
        setAuthenticated: (state, isAuthenticated) => 
        {
            state.isAuthenticated = isAuthenticated;
        },
        setError: (state, errmsg) => 
        {
            state.errmsg = errmsg;
        },
        clearError: (state) => 
        {
            state.errmsg = "";
        },
        setDestination: (state, destination) => 
        {
            state.destination = destination;
        },
    },

    actions: {
        signIn({ state, commit, dispatch }, authinfo) 
        {
            // console.log(`authinfo: ${JSON.stringify(authinfo)}`)
            var authentication_details = new AmazonCognitoIdentity.AuthenticationDetails({ Username: authinfo.Username, Password: authinfo.Password });
            var user_pool = new AmazonCognitoIdentity.CognitoUserPool(config.poolData);
            var user_data = { Username: authinfo.Username.toLowerCase(), Pool: user_pool }; // we force lowercase on the email
            var cognito_user = new AmazonCognitoIdentity.CognitoUser(user_data);

            commit("clearError");

            cognito_user.setAuthenticationFlowType("USER_PASSWORD_AUTH"); // must set this so the migration trigger is invoked
            // console.log(`authentication_details: ${JSON.stringify(authentication_details)}`)
            cognito_user.authenticateUser(authentication_details, {
                onSuccess: async function(result) 
                {
                    // console.log(`jwtToken: ${JSON.stringify(jwt(result.idToken.jwtToken))}`)
                    /* Use the idToken for Logins Map when Federating User Pools with identity pools or when passing through an Authorization Header to an API Gateway Authorizer */
                    commit("setIdToken", result.idToken.jwtToken);
                    // we also store the decoded jwt seperately for easy access to user attributes
                    commit("setProfile", jwt(result.idToken.jwtToken));
                    await dispatch("refreshFeatureFlags");
                    commit("setAuthenticated", true);

                    dispatch("gotoDestination");
                },
                onFailure: function(err) 
                {
                    console.error(`authenticateUser error: ${JSON.stringify(err)}`);
                    commit("setError", err.message);
                },
            });
        },
        refreshAuthTokens: function({ state, commit, dispatch }, force) 
        {
            console.log("refreshAuthTokens called, force flag is: " + force);

            var user_pool = new AmazonCognitoIdentity.CognitoUserPool(config.poolData);
            var cognito_user = user_pool.getCurrentUser();

            if (cognito_user != null) 
            {
                cognito_user.getSession(function(err, session) 
                {
                    let do_signout = false;

                    if (err) 
                    {
                        console.error(`getSession error: ${JSON.stringify(err)}`);
                        do_signout = true;
                    }
                    else if (router.currentRoute.path == "/logout") 
                    {
                        console.log("logout path detected");
                        do_signout = true;
                    }
                    else 
                    {
                        // be sure the pool is not set to remember devices or this won't work w/o passing DEVICE_KEY here
                        // also, if you use App client secret this will need the computed SECRET_HASH
                        // our pool is not using either so this is good to go
                        let refresh_token = session.getRefreshToken();

                        if (refresh_token) 
                        {
                            let id_token = jwt(session.getIdToken().getJwtToken());

                            // now we can get the the expiration field
                            let nowseconds = Math.floor(Date.now() / 1000); // convert to true unix timestamp (seconds, it's Java timestamp that is in mills)
                            let diff = id_token.exp - nowseconds;
                            console.log(`${diff - 720} seconds until session refresh`);

                            if (force || diff < 720) 
                            {
                                // if less than 12 minutes we refresh
                                cognito_user.refreshSession(refresh_token, async(err, session) =>
                                {
                                    if (err) 
                                    {
                                        console.error(`refreshSession error: ${JSON.stringify(err)}`);
                                        do_signout = true;
                                    }
                                    else 
                                    {
                                        // console.log("Session refreshed:\n" + JSON.stringify(session))

                                        /* Use the idToken for Logins Map when Federating User Pools with identity pools or when passing through an Authorization Header to an API Gateway Authorizer */
                                        commit("setIdToken", session.idToken.jwtToken);
                                        // we also store the decoded jwt seperately for easy access to user attributes
                                        commit("setProfile", jwt(session.idToken.jwtToken));
                                        await dispatch("refreshFeatureFlags");
                                        commit("setAuthenticated", true);
                                    }
                                });
                            }
                        }
                        else 
                        {
                            do_signout = true;
                        }
                    }
                    if (state.isAuthenticated && do_signout) 
                    {
                        // if we start the app after it's been away for awhile the session info is invalid
                        // so we detect those cases above and if needed force a signout
                        dispatch("signOut");
                    }
                });
            }
        },
        gotoDestination: function({ state, commit, dispatch }) 
        {
            // now we do some validation and send some users to the legacy portal
            let client_id = state.profile["custom:client_id"]
            let user_id = state.profile.preferred_username

            // all users for these clients go to the new portal
            let newportal_clients = [102, 116, 125, 144, 146, 147, 171]
            // for clients not in above list we refer to feature flag FF_Portal

            console.log(`checking destination for client id ${client_id}, user id '${user_id}'`)
            if (newportal_clients.find((c) => c == client_id) || (state.featureFlags.includes("FF_Portal")))
            {
                if (state.profile["custom:role"] === "branch" && state.featureFlags.includes("FF_Nexus_ASN"))
                {
                    window.location.assign("https://portal.qgistix.com/nexus")
                    return
                }

                router.push({ name: "home" })
            }
            else // we send other users to the v1 portal
            {
                // we set to not authenticated (but we keep the profile info) so this user can't come back and access the new portal
                commit("setAuthenticated", false);
                commit("setIdToken", null);

                // set legacy cookies here (there's similar code in App) so we can go directly to legacy portal, no interstitial page needed
                let domainroot = window.location.hostname
                    .split(".")
                    .reverse()
                    .splice(0, 2)
                    .reverse()
                    .join(".");
                cookies.set("qgbranch", state.profile["custom:brid"], 0, "/", domainroot);
                cookies.set("qgclient", state.profile["custom:client_id"], 0, "/", domainroot);
                cookies.set("qgname", state.profile.given_name, 0, "/", domainroot);
                cookies.set("qgrole", state.profile["custom:role"], 0, "/", domainroot);
                cookies.set("qguser", state.profile.preferred_username, 0, "/", domainroot);

                window.location.assign("https://www.qgistix.com/Portal.html");
            }
        },
        async refreshFeatureFlags({ state, commit, dispatch }) 
        {
            let response = await axios.get(config.QUS + "portal/user/" + encodeURIComponent(state.profile.email), { headers: { Authorization: state.idToken } });

            if (response.data[0]) 
            {
                // compute feature flags for this user
                let features = [response.data[0].org_features, response.data[0].user_features].join(" ");
                let disabled_features = [response.data[0].org_disabled_features, response.data[0].user_disabled_features].join(" ");

                // we filter out any features that are in the org or user disabled list
                let filtered_features = (features = features.split(" ").filter((el) => !disabled_features.includes(el)));
                console.log("filtered features: " + JSON.stringify(filtered_features));
                commit("setFeatureFlags", filtered_features);
            }
        },
        signOut: function({ state, commit, dispatch }, payload) 
        {
            if (state.profile && state.profile.email) 
            {
                var user_pool = new AmazonCognitoIdentity.CognitoUserPool(config.poolData);
                var user_data = { Username: state.profile.email, Pool: user_pool };
                var cognito_user = new AmazonCognitoIdentity.CognitoUser(user_data);

                cognito_user.signOut();
            }
            commit("setAuthenticated", false);
            commit("setProfile", null);
            commit("setIdToken", null);
            commit("setFeatureFlags", []);
            console.log("Logged out");
            router.push({ name: "home" }).catch((err) => {}); // we ignore duplicate route exception here
        },
    },
};
